package top.wcpe.allincore.dsl.compiler.semantic.`native`.methods

import top.wcpe.allincore.dsl.compiler.ast.ExprAst
import top.wcpe.allincore.dsl.compiler.diag.DiagnosticCollector
import top.wcpe.allincore.dsl.compiler.semantic.`native`.Arity
import top.wcpe.allincore.dsl.compiler.semantic.`native`.MethodDescriptor
import top.wcpe.allincore.dsl.compiler.semantic.`native`.ResolveCtx

/**
 * 内置 object {@code time} 的方法占位描述符集合。
 *
 * <p>仅做编译期"已知方法名 + 参数数量"校验，不参与 lower / 重写；与 LocalApiMethods 同款写法。</p>
 */

/** time.now()。 */
object TimeNowMethod : MethodDescriptor {
    override val name: String = "now"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** time.nowSeconds()。 */
object TimeNowSecondsMethod : MethodDescriptor {
    override val name: String = "nowSeconds"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** time.nanoTime()。 */
object TimeNanoTimeMethod : MethodDescriptor {
    override val name: String = "nanoTime"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** time.second()。 */
object TimeSecondMethod : MethodDescriptor {
    override val name: String = "second"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** time.minute()。 */
object TimeMinuteMethod : MethodDescriptor {
    override val name: String = "minute"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** time.hour()。 */
object TimeHourMethod : MethodDescriptor {
    override val name: String = "hour"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** time.format(ms, pattern)。 */
object TimeFormatMethod : MethodDescriptor {
    override val name: String = "format"
    override val arity: Arity = Arity.Fixed(2)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** time.elapsed(sinceMs)。 */
object TimeElapsedMethod : MethodDescriptor {
    override val name: String = "elapsed"
    override val arity: Arity = Arity.Fixed(1)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** 聚合 time 宿主 object 的所有方法描述符。 */
val TimeApiMethodMap: Map<String, MethodDescriptor> = listOf(
    TimeNowMethod,
    TimeNowSecondsMethod,
    TimeNanoTimeMethod,
    TimeSecondMethod,
    TimeMinuteMethod,
    TimeHourMethod,
    TimeFormatMethod,
    TimeElapsedMethod,
).associateBy { it.name }
